import Node from '../node.js';

export default class NodeNull extends Node
{
	constructor(pParent)
	{
		super(pParent);
	}

	getType()
	{
		return 'null';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		return inputValues[outputName];
	}
}